import { deposit as afgDeposit, getOutages, } from '@ally/data-selectors-afg-accounts';
import { AccountType } from '@ally/data-types-afg-accounts';
import { HowToSetUpPushApproveContent } from '@ally/shared-push-approve-modal';
export var coachmarkSchema = [
    {
        name: 'DEBT_PLAN',
        isCoachmarkEnabled: function (ffVariation) {
            return ffVariation('FF_debt-plan-snapshot', false);
        },
        scope: function (_a) {
            var pathname = _a.pathname;
            return pathname === '/dashboard';
        },
        summary: function () { return ({
            headline: {
                text: 'Manage and organize debt with a personalized plan.',
            },
            description: {
                text: "It's fresh, it's free and you've got early access.",
            },
            ctaLink: {
                text: 'Join our beta release',
                url: '/debt-plan',
            },
        }); },
    },
    {
        name: 'SPEND_BUCKETS_ONBOARDING',
        isCoachmarkEnabled: function (ffVariation) {
            return ffVariation('FF_spending-buckets', false);
        },
        scope: function (_a) {
            var hostData = _a.hostData, pathname = _a.pathname;
            var activeDepositAccounts = afgDeposit.getOpenInternal(hostData);
            var hasACheckingAccount = activeDepositAccounts.some(function (acc) { return acc.type === AccountType.DDA; });
            return pathname === '/dashboard' && hasACheckingAccount;
        },
        summary: function (_a) {
            var hostData = _a.hostData;
            var activeDepositAccounts = afgDeposit.getOpenInternal(hostData);
            var hasAnOsaWithMoreThanOneBucket = activeDepositAccounts.some(function (acc) {
                var _a, _b, _c, _d;
                return acc.type === AccountType.SDA &&
                    // BUCKET count greater than 1
                    ((_d = (_c = (_b = (_a = acc.meta) === null || _a === void 0 ? void 0 : _a.stkSummary) === null || _b === void 0 ? void 0 : _b.find(function (s) { return s.type === 'BUCKET'; })) === null || _c === void 0 ? void 0 : _c.count) !== null && _d !== void 0 ? _d : 0) >
                        1;
            });
            var checkingAccountWithHighestBalance = activeDepositAccounts
                .filter(function (acc) { return acc.type === AccountType.DDA; })
                .sort(
            // istanbul ignore next
            function (a, b) { var _a, _b, _c, _d; return ((_b = (_a = b.balance) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = a.balance) === null || _c === void 0 ? void 0 : _c.current) !== null && _d !== void 0 ? _d : 0); })[0];
            var url = "/account/".concat(checkingAccountWithHighestBalance.id, "/details");
            if (hasAnOsaWithMoreThanOneBucket) {
                return {
                    headline: {
                        text: 'The buckets you know and love, now in your checking account 💸',
                    },
                    description: {
                        text: 'Now you can set spending goals for yourself, too. Say hello to spending buckets.',
                    },
                    ctaLink: {
                        text: 'See what you can do',
                        url: url,
                        ariaLabel: 'See what you can do with spending buckets',
                    },
                };
            }
            return {
                headline: {
                    text: 'A better way to track your spending 💰',
                },
                description: {
                    text: 'Say goodbye to spreadsheets and hello to spending buckets.',
                },
                ctaLink: {
                    text: 'Start spending smarter',
                    url: url,
                    ariaLabel: 'Start spending smarter with spending buckets',
                },
            };
        },
    },
    {
        name: 'BADGES_ONBOARDING',
        isCoachmarkEnabled: function (ffVariation) {
            return ffVariation('FF_badge-widget', true);
        },
        scope: function (_a) {
            var hostData = _a.hostData, pathname = _a.pathname;
            var isBankOutage = getOutages(hostData).DEPOSIT === 'full';
            return (['/dashboard', '/guest-dashboard'].includes(pathname) && !isBankOutage);
        },
        summary: function () { return ({
            headline: {
                text: 'Introducing: Badges 🤩',
            },
            description: {
                text: 'Now you’ll see badges on your Snapshot celebrating your latest Ally milestones and achievements.',
            },
            ctaLink: {
                text: 'Got it',
                ariaLabel: 'Got it',
            },
        }); },
    },
    {
        name: 'PREFERRED_NAME_ONBOARDING',
        isCoachmarkEnabled: function (ffVariation) {
            return ffVariation('FF_preferred-name-pronoun', false);
        },
        scope: function (_a) {
            var pathname = _a.pathname, allyUserRole = _a.allyUserRole;
            var isBankUser = allyUserRole.bank;
            var isInvestUser = allyUserRole.investment;
            return (['/dashboard', '/guest-dashboard'].includes(pathname) &&
                (isBankUser || isInvestUser));
        },
        summary: function () { return ({
            headline: {
                text: "Let's get better acquainted.",
            },
            description: {
                text: 'Tell us your pronouns and preferred name so we can address you the way you want.',
            },
            ctaLink: {
                text: 'Go to Profile',
                ariaLabel: 'Go to Profile',
                url: '/profile',
            },
        }); },
    },
    {
        name: 'MORTGAGE_DEEP_LINK',
        isCoachmarkEnabled: function (ffVariation) {
            return ffVariation('FF_mortgage-deeplinking', false);
        },
        scope: function (_a) {
            var _b, _c, _d;
            var pathname = _a.pathname, allyUserRole = _a.allyUserRole, session = _a.session;
            var isMortgageUser = allyUserRole.mortgage;
            var hasHomeLoansRelationship = ((_d = (_c = (_b = session.data) === null || _b === void 0 ? void 0 : _b.relationships.mortgage) === null || _c === void 0 ? void 0 : _c.servicing) === null || _d === void 0 ? void 0 : _d.indicator) === 'YES';
            return (['/dashboard'].includes(pathname) &&
                isMortgageUser &&
                hasHomeLoansRelationship);
        },
        summary: function () { return ({
            headline: {
                text: 'Do more with your home loan accounts from anywhere in Ally',
            },
            description: {
                text: 'Make a payment, find your documents, and change paperless settings with new actions on our menus and your Snapshot.',
            },
            ctaLink: {
                text: '',
            },
        }); },
    },
    {
        name: 'MOBILE_APPROVE_ONBOARDING',
        isCoachmarkEnabled: function (ffVariation) {
            return ffVariation('FF_mobile-approve-onboarding-coachmark', false);
        },
        scope: function (_scopeContext) {
            return true;
        },
        summary: function () { return ({
            headline: {
                text: 'Get enhanced login security.',
            },
            description: {
                text: "We'll send you a push notification any time we need you to verify a login attempt.",
            },
            ctaLink: {
                text: 'Set it up for future logins.',
            },
        }); },
        detailView: {
            Component: HowToSetUpPushApproveContent,
        },
    },
];
// this makes testing easier (should only be imported in tests)
export var schemaAliases = {
    debtPlanSchema: coachmarkSchema[0],
    spendingBucketsSchema: coachmarkSchema[1],
    badgeWidgetOnboardingSchema: coachmarkSchema[2],
    preferredNameOnboardingSchema: coachmarkSchema[3],
    mortgageDeepLinkSchema: coachmarkSchema[4],
    mobileApproveOnboardingSchema: coachmarkSchema[5],
};
//# sourceMappingURL=schema.js.map